import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/query/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchProducersOrganizations(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/query/fetch_producers_organizations/${packing_house_process_id}/${container_id}`
    );
  },
  fetchCropFields(packing_house_process_id, container_id, producer_id, organization_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/query/fetch_crop_fields/${packing_house_process_id}/${container_id}?producer_id=${producer_id}&organization_id=${organization_id}`
    );
  }
};
